import { Form, Modal } from "react-bootstrap";
import React from "react";
import { getFilteredVehicleOptions } from "../vehicles";
import { useProviderOptions } from "../../store/actions/providerActions";

export default function FiltersModal({ show, setShow, filters, setFilters, userInfos }) {
  const providerOptions = useProviderOptions();
  const filteredVehicleOptions = getFilteredVehicleOptions(userInfos);

  function updateFilter(filter, value) {
    setFilters((old) => ({ ...old, [filter]: value }));
  }

  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Filtres</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="vehicleTypeFilter">
            <Form.Label>Type de véhicule</Form.Label>
            <Form.Control
              as="select"
              value={filters.vehicle}
              onChange={(e) => updateFilter("vehicle", e.target.value)}
            >
              <option value="">Tout</option>
              {filteredVehicleOptions.map((vehicle) => (
                <option key={vehicle.value} value={vehicle.value}>
                  {vehicle.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="providerFilter">
            <Form.Label>Client</Form.Label>
            <Form.Control
              as="select"
              value={filters.provider}
              onChange={(e) => updateFilter("provider", e.target.value)}
            >
              <option value="">Tout</option>
              {providerOptions.map((provider) => (
                <option key={provider.value} value={provider.label}>
                  {provider.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {/*<Button variant="secondary" onClick={() => setShow(false)}>*/}
        {/*  Fermer*/}
        {/*</Button>*/}
      </Modal.Footer>
    </Modal>
  );
}
